const texts = {
    "money-back": {
        EN: "Money back",
        DA: "Penge tilbage",
        DE: "Geld zurück",
        NL: "Geld terug",
        FR: "Remboursement",
        IT: "Rimborso",
        ES: "Reembolso",
        PT: "Dinheiro de volta",
        FI: "Rahat takaisin",
        SV: "Återbetalning",
        NO: "Pengene tilbake",
    },

    "money-back-negative": {
        EN: "Money to be paid",
        DA: "Penge at betale",
        DE: "Zu zahlender Betrag",
        NL: "Te betalen bedrag",
        FR: "Montant à payer",
        IT: "Importo da pagare",
        ES: "Dinero a pagar",
        PT: "Valor a pagar",
        FI: "Maksettava summa",
        SV: "Belopp att betala",
        NO: "Beløp å betale",
    },

    "free-exchange": {
        EN: "Free exchange",
        DA: "Gratis ombytning",
        DE: "Kostenloser Umtausch",
        NL: "Gratis ruilen",
        FR: "Échange gratuit",
        IT: "Cambio gratuito",
        ES: "Cambio gratuito",
        PT: "Troca gratuita",
        FI: "Ilmainen vaihto",
        SV: "Gratis byte",
        NO: "Gratis bytte",
    },
};

export default texts;
